import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TableLazyLoadEvent } from 'primeng/table';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { MenuItem } from 'primeng/api';
// migrated 1:1 from @nexato/nx-core-module (#682)
import { NXDataSourcePrime } from '../../../services/dataSource/NXDataSourcePrime';
import { IssueType } from '../../../entities/issue/issue-type';
import { Observable, of, switchMap, take } from 'rxjs';
import { ApolloService } from '../../../services/apollo.service';
import * as fromGraphQl from './graphql';
import { Reloadable } from '../../../services/command/command.service';
import { IssueTypesDataSource } from './issue-types.datasource';
import { IssueStatusGroup } from '../../../entities/issue/issue-status-group';
import { IssueStatusGroupService } from '../../../services/issue/issueStatusGroups/issueStatusGroup.service';

@Component({
  selector: 'app-issue-status-groups',
  templateUrl: './issue-types.component.html',
  styleUrls: ['./issue-types.component.scss']
})
export class IssueStatusGrojupsComponent implements OnInit, Reloadable {

  dialogRef: DynamicDialogRef | undefined;

  public loading = false;
  public issueStatusGroups: IssueStatusGroup[];
  public selectedIssueStatusGroup: IssueStatusGroup | undefined;

  public reloadable = this;

  constructor(
    private apollo: Apollo,
    @Inject('env') public environment: any,
    private cdRef: ChangeDetectorRef,
    private issueStatusGroupService: IssueStatusGroupService
  ) {
  }

  reload(): void {
    this.loadIssueStatusGroups();
  }

  ngOnInit(): void {
    this.loadIssueStatusGroups();
  }

  onRowSelect(): void {
   console.log('Selected Issue Status Group:', this.selectedIssueStatusGroup);
  }


  private loadIssueStatusGroups(): void {
    this.loading = true;
    this.issueStatusGroupService.getIssueStatusGroups()
      .subscribe({
        next: (groups) => {
          this.issueStatusGroups = groups;
          this.loading = false;
          this.cdRef.detectChanges();
        },
        error: (error) => {
          this.loading = false;
          this.cdRef.detectChanges();
        }
      });
  }


}

